/* this data is dervived from a text file that Inquisitor 40k uses on your local PC, probably in your Documents or under Steam 
 * I forget its name :( I could look but I'm on my apple machine writing this :/ 
*/

// Data structure looks like
// {
// 'relic': {
//   'weapon': {
//      'Plasma Caliver': ['enchantments by description']
//    }
//  }
// }
const ItemMap = {};


         
const Enchant = (tagname, desc, items, slots, quality, doubled, groupd, seasons) => {
  slots.forEach((slot) => {
    items.forEach((item) => {
      if(ItemMap[slot]){
        if(ItemMap[slot][quality]){
          if(ItemMap[slot][quality][item]) { 
            //  sometimes Euipment Module is listed twice, reason unknown, hence checking if already included
            if(!ItemMap[slot][quality][item].includes(desc) ) {
              ItemMap[slot][quality][item].push(desc)
            }
          } else ItemMap[slot][quality][item] = [desc]; 
        } else ItemMap[slot][quality] = {[item]:[desc]};
      } else ItemMap[slot] = {[quality]:{[item]:[desc]}};
    });  
  });
}

const EnchantmentsMap = [

Enchant('minion_chance_to_burn_on_hit',
         "All Construct Heat attacks apply <font color='#fe7272'>Inferno</font> on Hit with a <font color='#2bede6'>+15%</font> chance",
         ['Plasma Caliver','Omnissian Axe','Radium Carbine','Voltaic Axe'],
         ['weapon'],
         'relic',
         false,
         [],
         [1]),
Enchant('minion_damage',
         "30.0% to 45.0% Damage Bonus",
         ['Equipment Module','Equipment Module'],
         ['construct'],
         'primary',
         false,
         [],
         [0]),
Enchant('minion_damage_against_bleeding',
         "40.0% to 65.0% Damage Bonus for the <font color='#00a1ff'>Construct</font> against <font color='#2bede6'>Bleeding</font> enemies ",
         ['Equipment Module','Equipment Module'],
         ['construct'],
         'primary',
         false,
         [],
         [0]),
Enchant('minion_damage_against_bleeding_minor',
         "35.0% to 75.0% Damage Bonus for <font color='#00a1ff'>Constructs</font> against <font color='#2bede6'>Bleeding</font> enemies ",
         ['Plasma Caliver','Arc Sword','Assassin Power Sword','Autogun','Boltgun','Carthean Sword','Eviscerator','Exitus Rifle','Force Staff','Pyrokinetic Staff','Wyrdvane Staff','Grav-Gun','Greataxe','Greatsword','Grenade Launcher','Heavy Bolter','Heavy Flamer','Lasgun','Longlas Rifle','Melta Gun','Multi-Melta','Needler Sniper Rifle','Neural Implant','Omnissian Axe','Plasma Cannon','Plasma Gun','Radium Carbine','Shotgun','Sniper Rifle','Thunder Hammer','Voltaic Axe'],
         ['neural_implant','weapon'],
         'secondary',
         false,
         [],
         [0]),
Enchant('minion_damage_against_burning',
         "40.0% to 65.0% Damage Bonus for the <font color='#00a1ff'>Construct</font> against <font color='#2bede6'>Burning</font> enemies ",
         ['Equipment Module','Equipment Module'],
         ['construct'],
         'primary',
         false,
         [],
         [0]),
Enchant('minion_damage_against_burning_minor',
         "35.0% to 75.0% Damage Bonus for <font color='#00a1ff'>Constructs</font> against <font color='#2bede6'>Burning</font> enemies ",
         ['Plasma Caliver','Arc Sword','Assassin Power Sword','Autogun','Boltgun','Carthean Sword','Eviscerator','Exitus Rifle','Force Staff','Pyrokinetic Staff','Wyrdvane Staff','Grav-Gun','Greataxe','Greatsword','Grenade Launcher','Heavy Bolter','Heavy Flamer','Lasgun','Longlas Rifle','Melta Gun','Multi-Melta','Needler Sniper Rifle','Neural Implant','Omnissian Axe','Plasma Cannon','Plasma Gun','Radium Carbine','Shotgun','Sniper Rifle','Thunder Hammer','Voltaic Axe'],
         ['neural_implant','weapon'],
         'secondary',
         false,
         [],
         [0]),
Enchant('minion_damage_against_medium',
         "40.0% to 65.0% Damage Bonus for the <font color='#00a1ff'>Construct</font> against <font color='#2bede6'>Champion</font> enemies ",
         ['Equipment Module','Equipment Module'],
         ['construct'],
         'primary',
         false,
         ['damage_percent_against_size'],
         [0]),
Enchant('minion_damage_against_normal',
         "40.0% to 65.0% Damage Bonus for the <font color='#00a1ff'>Construct</font> against <font color='#2bede6'>Regular</font> enemies ",
         ['Equipment Module','Equipment Module'],
         ['construct'],
         'primary',
         false,
         ['damage_percent_against_size'],
         [0]),
Enchant('minion_damage_against_poisoned',
         "40.0% to 65.0% Damage Bonus for the <font color='#00a1ff'>Construct</font> against <font color='#2bede6'>Poisoned</font> enemies ",
         ['Equipment Module','Equipment Module'],
         ['construct'],
         'primary',
         false,
         [],
         [0]),
Enchant('minion_damage_against_poisoned_minor',
         "35.0% to 75.0% Damage Bonus for <font color='#00a1ff'>Constructs</font> against <font color='#2bede6'>Poisoned</font> enemies ",
         ['Plasma Caliver','Arc Sword','Assassin Power Sword','Autogun','Boltgun','Carthean Sword','Eviscerator','Exitus Rifle','Force Staff','Pyrokinetic Staff','Wyrdvane Staff','Grav-Gun','Greataxe','Greatsword','Grenade Launcher','Heavy Bolter','Heavy Flamer','Lasgun','Longlas Rifle','Melta Gun','Multi-Melta','Needler Sniper Rifle','Neural Implant','Omnissian Axe','Plasma Cannon','Plasma Gun','Radium Carbine','Shotgun','Sniper Rifle','Thunder Hammer','Voltaic Axe'],
         ['neural_implant','weapon'],
         'secondary',
         false,
         [],
         [0]),
Enchant('minion_damage_against_shocked_slowed',
         "40.0% to 65.0% Damage Bonus for the <font color='#00A1FF'>Construct</font> against <font color='#2bede6'>Shocked,Slowed</font> enemies ",
         ['Equipment Module','Equipment Module'],
         ['construct'],
         'primary',
         false,
         [],
         [0]),
Enchant('minion_damage_against_shocked_slowed_minor',
         "35.0% to 75.0% Damage Bonus for <font color='#00A1FF'>Constructs</font> against <font color='#2bede6'>Shocked,Slowed</font> enemies ",
         ['Plasma Caliver','Arc Sword','Assassin Power Sword','Autogun','Boltgun','Carthean Sword','Eviscerator','Exitus Rifle','Force Staff','Pyrokinetic Staff','Wyrdvane Staff','Grav-Gun','Greataxe','Greatsword','Grenade Launcher','Heavy Bolter','Heavy Flamer','Lasgun','Longlas Rifle','Melta Gun','Multi-Melta','Needler Sniper Rifle','Neural Implant','Omnissian Axe','Plasma Cannon','Plasma Gun','Radium Carbine','Shotgun','Sniper Rifle','Thunder Hammer','Voltaic Axe'],
         ['neural_implant','weapon'],
         'secondary',
         false,
         [],
         [0]),
Enchant('minion_damage_against_stunned',
         "40.0% to 65.0% Damage Bonus for the <font color='#00a1ff'>Construct</font> against <font color='#2bede6'>Stunned</font> enemies ",
         ['Equipment Module','Equipment Module'],
         ['construct'],
         'primary',
         false,
         [],
         [0]),
Enchant('minion_damage_against_stunned_minor',
         "35.0% to 75.0% Damage Bonus for <font color='#00a1ff'>Constructs</font> against <font color='#2bede6'>Stunned</font> enemies ",
         ['Plasma Caliver','Arc Sword','Assassin Power Sword','Autogun','Boltgun','Carthean Sword','Eviscerator','Exitus Rifle','Force Staff','Pyrokinetic Staff','Wyrdvane Staff','Grav-Gun','Greataxe','Greatsword','Grenade Launcher','Heavy Bolter','Heavy Flamer','Lasgun','Longlas Rifle','Melta Gun','Multi-Melta','Needler Sniper Rifle','Neural Implant','Omnissian Axe','Plasma Cannon','Plasma Gun','Radium Carbine','Shotgun','Sniper Rifle','Thunder Hammer','Voltaic Axe'],
         ['neural_implant','weapon'],
         'secondary',
         false,
         [],
         [0]),
Enchant('minion_damage_on_death_explosion_crawler',
         "0.35 to 0.55 Damage Bonus for the Self-destruct Skill for <font color='#00a1ff'>Psiloi Vivisectors</font>",
         ['Belt Equipment','Force Field','Grenade','Mine','Psychic Focus','Archeotech Item','Weapon Module'],
         ['belt','construct'],
         'primary',
         false,
         [],
         [0]),
Enchant('minion_damage_on_death_explosion_kastelan',
         "0.3 to 0.45 Damage Bonus for the Self-destruct Skill for <font color='#00a1ff'>Kastelan Robots</font>",
         ['Weapon Module','Weapon Module'],
         ['construct'],
         'primary',
         false,
         [],
         [0]),
Enchant('minion_damage_reduce',
         "15.0 to 20.0 Damage Reduction",
         ['Equipment Module','Equipment Module','Equipment Module','Equipment Module'],
         ['construct'],
         'primary',
         false,
         [],
         [0]),
Enchant('minion_fear_on_hit',
         "25.0% to 35.0% chance to <font color='#2bede6'>Fear</font> on Hit",
         ['Belt Equipment','Force Field','Grenade','Mine','Psychic Focus','Archeotech Item','Purity Seal'],
         ['belt','purity_seal'],
         'primary',
         false,
         ['fear_on'],
         [0]),
Enchant('minion_heat_damage',
         "30.0% to 45.0% Heat Damage Bonus",
         ['Equipment Module','Equipment Module'],
         ['construct'],
         'primary',
         false,
         [],
         [0]),
Enchant('minion_heat_resist',
         "45.0 to 50.0 Heat Resistance",
         ['Equipment Module','Equipment Module','Equipment Module','Equipment Module','Equipment Module','Weapon Module'],
         ['construct'],
         'primary',
         false,
         [],
         [0]),
Enchant('minion_hp',
         "0.07 to 0.12 HP",
         ['Equipment Module','Equipment Module','Equipment Module','Equipment Module','Equipment Module','Weapon Module'],
         ['construct'],
         'primary',
         false,
         [],
         [0]),
Enchant('minion_hp_module_combustor',
         "400.0 to 600.0 HP for the construct if equipped on <font color='#00A1FF'>Psiloi Combustor</font> ",
         ['Equipment Module','Equipment Module'],
         ['construct'],
         'primary',
         false,
         ['MinionSpec'],
         [0]),
Enchant('minion_hp_module_kastellan',
         "500.0 to 800.0 HP for the construct if equipped on <font color='#00A1FF'>Kastelan Robot</font> ",
         ['Equipment Module','Equipment Module'],
         ['construct'],
         'primary',
         false,
         ['MinionSpec'],
         [0]),
Enchant('minion_hp_module_kataphron_destroyer',
         "450.0 to 550.0 HP for the construct if equipped on <font color='#00A1FF'>Kataphron Destroyer</font> ",
         ['Equipment Module','Equipment Module'],
         ['construct'],
         'primary',
         false,
         ['MinionSpec'],
         [0]),
Enchant('minion_hp_module_kataphron_vanguard',
         "550.0 to 675.0 HP for the construct if equipped on <font color='#00A1FF'>Kataphron Vanguard</font> ",
         ['Equipment Module','Equipment Module'],
         ['construct'],
         'primary',
         false,
         ['MinionSpec'],
         [0]),
Enchant('minion_hp_module_tarantula',
         "450.0 to 550.0 HP for the construct if equipped on <font color='#00A1FF'>Tarantula Turret</font> ",
         ['Equipment Module','Equipment Module'],
         ['construct'],
         'primary',
         false,
         ['MinionSpec'],
         [0]),
Enchant('minion_hp_module_vivisector',
         "165.0 to 225.0 HP for the construct if equipped on <font color='#00A1FF'>Psiloi Vivisector</font> ",
         ['Equipment Module','Equipment Module'],
         ['construct'],
         'primary',
         false,
         ['MinionSpec'],
         [0]),
Enchant('minion_hp_per_kill',
         "400.0 to 800.0 HP gained on Kill",
         ['Equipment Module','Equipment Module'],
         ['construct'],
         'primary',
         false,
         [],
         [0]),
Enchant('minion_hp_regen',
         "6.0 to 10.0 HP Regeneration per second",
         ['Equipment Module','Equipment Module','Equipment Module','Weapon Module'],
         ['construct'],
         'primary',
         false,
         [],
         [0]),
Enchant('minion_knockback_on_hit',
         "6.0% to 10.0% chance to <font color='#2bede6'>Knockback</font> on Hit",
         ['Equipment Module','Equipment Module'],
         ['construct'],
         'primary',
         true,
         ['knockback_on'],
         [0]),
Enchant('minion_lifeleech_melee',
         "55.0 to 85.0% Life Drain",
         ['Equipment Module','Equipment Module'],
         ['construct'],
         'primary',
         false,
         [],
         [0]),
Enchant('minion_lifeleech_ranged',
         "40.0 to 55.0% Life Drain",
         ['Equipment Module','Equipment Module'],
         ['construct'],
         'primary',
         false,
         [],
         [0]),
Enchant('minion_melee_damage',
         "6.0% to 10.0% Melee Damage Bonus",
         ['Equipment Module','Equipment Module'],
         ['construct'],
         'primary',
         false,
         [],
         [0]),
Enchant('minion_physical_damage',
         "6.0% to 10.0% Physical Damage Bonus",
         ['Equipment Module','Equipment Module'],
         ['construct'],
         'primary',
         false,
         [],
         [0]),
Enchant('minion_physical_resist',
         "45.0 to 50.0 Physical Resistance",
         ['Equipment Module','Equipment Module','Equipment Module','Equipment Module','Equipment Module','Weapon Module'],
         ['construct'],
         'primary',
         false,
         [],
         [0]),
Enchant('minion_ranged_damage',
         "6.0% to 10.0% Ranged Damage Bonus",
         ['Equipment Module','Equipment Module'],
         ['construct'],
         'primary',
         false,
         [],
         [0]),
Enchant('minion_shield_regen',
         "6.0 to 10.0 Energy Shield Regeneration per second",
         ['Equipment Module','Weapon Module'],
         ['construct'],
         'primary',
         false,
         [],
         [0]),
Enchant('minion_suppression_damage',
         "6.0% to 10.0% Suppression Damage Bonus",
         ['Equipment Module','Equipment Module'],
         ['construct'],
         'primary',
         false,
         [],
         [0]),
Enchant('minion_ta_damage_combustor_autogun',
         "0.22 to 0.35 Damage Bonus for the <font color='#2bede6'>Autogun Shot</font> Skill of the <font color='#00a1ff'>Psiloi Combustor</font> ",
         ['Plasma Caliver','Main Implant','Omnissian Axe','Radium Carbine','Voltaic Axe'],
         ['main_implant','weapon'],
         'primary',
         false,
         [],
         [0]),
Enchant('minion_ta_damage_combustor_las',
         "0.22 to 0.35 Damage Bonus for the <font color='#2bede6'>Lasgun Shot</font> Skill of the <font color='#00a1ff'>Psiloi Combustor</font> ",
         ['Plasma Caliver','Main Implant','Omnissian Axe','Radium Carbine','Voltaic Axe'],
         ['main_implant','weapon'],
         'primary',
         false,
         [],
         [0]),
Enchant('minion_ta_damage_combustor_melta',
         "0.22 to 0.35 Damage Bonus for the <font color='#2bede6'>Meltagun Shot</font> Skill of the <font color='#00a1ff'>Psiloi Combustor</font> ",
         ['Plasma Caliver','Main Implant','Omnissian Axe','Radium Carbine','Voltaic Axe'],
         ['main_implant','weapon'],
         'primary',
         false,
         [],
         [0]),
Enchant('minion_ta_damage_flat',
         "8.0 to 12.0 base Damage for <font color='#00a1ff'>Constructs</font>",
         ['Eye Implant','Purity Seal','Signum'],
         ['eye_implant','purity_seal','signum'],
         'primary',
         false,
         [],
         [0]),
Enchant('minion_ta_damage_kastellan_aoe',
         "0.55 to 0.75 Damage Bonus for the <font color='#2bede6'>Litany of the Electromancer</font> Skill of the <font color='#00a1ff'>Kastelan Robot</font> ",
         ['Plasma Caliver','Main Implant','Omnissian Axe','Radium Carbine','Voltaic Axe'],
         ['main_implant','weapon'],
         'primary',
         false,
         [],
         [0]),
Enchant('minion_ta_damage_kastellan_blaster_burst',
         "0.22 to 0.35 Damage Bonus for the <font color='#2bede6'>Phosphorus Blast</font> Skill of the Phospor Gun of the <font color='#00a1ff'>Kastelan Robot</font> ",
         ['Plasma Caliver','Main Implant','Omnissian Axe','Radium Carbine','Voltaic Axe'],
         ['main_implant','weapon'],
         'primary',
         false,
         [],
         [0]),
Enchant('minion_ta_damage_kastellan_blaster_shoot',
         "0.22 to 0.35 Damage Bonus for the <font color='#2bede6'>Phosphorus Barrage</font> Skill of the Phospor Gun of the <font color='#00a1ff'>Kastelan Robot</font> ",
         ['Plasma Caliver','Main Implant','Omnissian Axe','Radium Carbine','Voltaic Axe'],
         ['main_implant','weapon'],
         'primary',
         false,
         [],
         [0]),
Enchant('minion_ta_damage_kastellan_fist_cleave',
         "0.22 to 0.35 Damage Bonus for the <font color='#2bede6'>Fist Cleave</font> Skill of the <font color='#00a1ff'>Kastelan Robot</font> ",
         ['Plasma Caliver','Main Implant','Omnissian Axe','Radium Carbine','Voltaic Axe'],
         ['main_implant','weapon'],
         'primary',
         false,
         [],
         [0]),
Enchant('minion_ta_damage_kastellan_fist_shoot',
         "0.22 to 0.35 Damage Bonus for the <font color='#2bede6'>Phosphor Cannon</font> Weapon of the <font color='#00a1ff'>Kastelan Robot</font> ",
         ['Plasma Caliver','Main Implant','Omnissian Axe','Radium Carbine','Voltaic Axe'],
         ['main_implant','weapon'],
         'primary',
         false,
         [],
         [0]),
Enchant('minion_ta_damage_kastellan_fist_strike',
         "0.22 to 0.35 Damage Bonus for the <font color='#2bede6'>Fist Strike</font> Skill of the <font color='#00a1ff'>Kastelan Robot</font> ",
         ['Plasma Caliver','Main Implant','Omnissian Axe','Radium Carbine','Voltaic Axe'],
         ['main_implant','weapon'],
         'primary',
         false,
         [],
         [0]),
Enchant('minion_ta_damage_kastellan_flamer_flame',
         "0.22 to 0.35 Damage Bonus for the <font color='#2bede6'>Flame Stream</font> Skill of the Flamer of the <font color='#00a1ff'>Kastelan Robot</font> ",
         ['Plasma Caliver','Main Implant','Omnissian Axe','Radium Carbine','Voltaic Axe'],
         ['main_implant','weapon'],
         'primary',
         false,
         [],
         [0]),
Enchant('minion_ta_damage_kastellan_flamer_shot',
         "0.22 to 0.35 Damage Bonus for the <font color='#2bede6'>Flame Burst</font> Skill of the Flamer of the <font color='#00a1ff'>Kastelan Robot</font> ",
         ['Plasma Caliver','Main Implant','Omnissian Axe','Radium Carbine','Voltaic Axe'],
         ['main_implant','weapon'],
         'primary',
         false,
         [],
         [0]),
Enchant('minion_ta_damage_kataphron_aoe',
         "0.55 to 0.75 Damage Bonus for the <font color='#2bede6'>Canticles of the Omnissiah</font> Skill of the <font color='#00a1ff'>Kataphron Vanguard</font> ",
         ['Plasma Caliver','Main Implant','Omnissian Axe','Radium Carbine','Voltaic Axe'],
         ['main_implant','weapon'],
         'primary',
         false,
         [],
         [0]),
Enchant('minion_ta_damage_kataphron_charge',
         "0.55 to 0.75 Damage Bonus for the <font color='#2bede6'>Charge</font> Skill of the <font color='#00a1ff'>Kataphron Vanguard</font> ",
         ['Plasma Caliver','Main Implant','Omnissian Axe','Radium Carbine','Voltaic Axe'],
         ['main_implant','weapon'],
         'primary',
         false,
         [],
         [0]),
Enchant('minion_ta_damage_kataphron_cleave',
         "0.22 to 0.35 Damage Bonus for the <font color='#2bede6'>Greataxe</font> weapon of the <font color='#00a1ff'>Kataphron Vanguard</font> ",
         ['Plasma Caliver','Main Implant','Omnissian Axe','Radium Carbine','Voltaic Axe'],
         ['main_implant','weapon'],
         'primary',
         false,
         [],
         [0]),
Enchant('minion_ta_damage_kataphron_flamer',
         "0.22 to 0.35 Damage Bonus for the <font color='#2bede6'>Flamer</font> weapon of the <font color='#00a1ff'>Kataphron Destroyer</font> ",
         ['Plasma Caliver','Main Implant','Omnissian Axe','Radium Carbine','Voltaic Axe'],
         ['main_implant','weapon'],
         'primary',
         false,
         [],
         [0]),
Enchant('minion_ta_damage_kataphron_gravcannon',
         "0.22 to 0.35 Damage Bonus for the <font color='#2bede6'>Gravcannon</font> weapon of the <font color='#00a1ff'>Kataphron Destroyer</font> ",
         ['Plasma Caliver','Main Implant','Omnissian Axe','Radium Carbine','Voltaic Axe'],
         ['main_implant','weapon'],
         'primary',
         false,
         [],
         [0]),
Enchant('minion_ta_damage_kataphron_phosphor',
         "0.22 to 0.35 Damage Bonus for the <font color='#2bede6'>Phosphor Blaster</font> weapon of the <font color='#00a1ff'>Kataphron Destroyer</font> ",
         ['Plasma Caliver','Main Implant','Omnissian Axe','Radium Carbine','Voltaic Axe'],
         ['main_implant','weapon'],
         'primary',
         false,
         [],
         [0]),
Enchant('minion_ta_damage_kataphron_plasma',
         "0.22 to 0.35 Damage Bonus for the <font color='#2bede6'>Plasma cannon</font> weapon of the <font color='#00a1ff'>Kataphron Destroyer</font> ",
         ['Plasma Caliver','Main Implant','Omnissian Axe','Radium Carbine','Voltaic Axe'],
         ['main_implant','weapon'],
         'primary',
         false,
         [],
         [0]),
Enchant('minion_ta_damage_kataphron_strike',
         "0.22 to 0.35 Damage Bonus for the <font color='#2bede6'>Power Axe</font> weapon of the <font color='#00a1ff'>Kataphron Vanguard</font> ",
         ['Plasma Caliver','Main Implant','Omnissian Axe','Radium Carbine','Voltaic Axe'],
         ['main_implant','weapon'],
         'primary',
         false,
         [],
         [0]),
Enchant('minion_ta_damage_on_death_explosion_crawler',
         "0.2 to 0.3 Damage Bonus for the Self-destruct Skill for <font color='#00a1ff'>Psiloi Vivisectors</font>",
         ['Belt Equipment','Force Field','Grenade','Mine','Psychic Focus','Archeotech Item'],
         ['belt'],
         'primary',
         false,
         [],
         [0]),
Enchant('minion_ta_damage_on_death_explosion_kastelan',
         "0.2 to 0.3 Damage Bonus for the Self-destruct Skill for <font color='#00a1ff'>Kastelan Robots</font>",
         ['Belt Equipment','Force Field','Grenade','Mine','Psychic Focus','Archeotech Item'],
         ['belt'],
         'primary',
         false,
         [],
         [0]),
Enchant('minion_ta_damage_reduce',
         "12.0 to 20.0 Supreme Damage Reduction for <font color='#00a1ff'>Constructs</font> ",
         ['Belt Equipment','Force Field','Grenade','Mine','Psychic Focus','Archeotech Item','Power Armour','Light Armour','Synskin Armour','Tech-adept Armour'],
         ['belt','body'],
         'primary',
         false,
         [],
         [0]),
Enchant('minion_ta_damage_reduce_minor',
         "1.0 to 2.0 Damage Reduction for <font color='#00a1ff'>Constructs</font> ",
         ['Eye Implant','Inoculator','Main Implant','Neural Implant','Purity Seal'],
         ['eye_implant','inoculator','main_implant','neural_implant','purity_seal'],
         'secondary',
         false,
         [],
         [0]),
Enchant('minion_ta_damage_tarantula_bolter',
         "0.22 to 0.35 Damage Bonus for the <font color='#2bede6'>Boltgun Shoot</font> Skill of the <font color='#00a1ff'>Tarantula Turret</font> ",
         ['Plasma Caliver','Main Implant','Omnissian Axe','Radium Carbine','Voltaic Axe'],
         ['main_implant','weapon'],
         'primary',
         false,
         [],
         [0]),
Enchant('minion_ta_damage_tarantula_flamer',
         "0.22 to 0.35 Damage Bonus for the <font color='#2bede6'>Flame Stream</font> Skill of the <font color='#00a1ff'>Tarantula Turret</font> ",
         ['Plasma Caliver','Main Implant','Omnissian Axe','Radium Carbine','Voltaic Axe'],
         ['main_implant','weapon'],
         'primary',
         false,
         [],
         [0]),
Enchant('minion_ta_damage_tarantula_lasgun',
         "0.22 to 0.35 Damage Bonus for the <font color='#2bede6'>Lasgun Shoot</font> Skill of the <font color='#00a1ff'>Tarantula Turret</font> ",
         ['Plasma Caliver','Main Implant','Omnissian Axe','Radium Carbine','Voltaic Axe'],
         ['main_implant','weapon'],
         'primary',
         false,
         [],
         [0]),
Enchant('minion_ta_damage_tarantula_launcher',
         "0.22 to 0.35 Damage Bonus for the <font color='#2bede6'>Missile Launch</font> Skill of the <font color='#00a1ff'>Tarantula Turret</font> ",
         ['Plasma Caliver','Main Implant','Omnissian Axe','Radium Carbine','Voltaic Axe'],
         ['main_implant','weapon'],
         'primary',
         false,
         [],
         [0]),
Enchant('minion_ta_damage_vivisector_chainsaw',
         "0.22 to 0.35 Damage Bonus for the <font color='#2bede6'>Chainsaw Eviscerate</font> Skill of the <font color='#00a1ff'>Psiloi Vivisector</font> ",
         ['Plasma Caliver','Main Implant','Omnissian Axe','Radium Carbine','Voltaic Axe'],
         ['main_implant','weapon'],
         'primary',
         false,
         [],
         [0]),
Enchant('minion_ta_damage_vivisector_claw',
         "0.22 to 0.35 Damage Bonus for the <font color='#2bede6'>Claw Strike</font> Skill of the <font color='#00a1ff'>Psiloi Vivisector</font> ",
         ['Plasma Caliver','Main Implant','Omnissian Axe','Radium Carbine','Voltaic Axe'],
         ['main_implant','weapon'],
         'primary',
         false,
         [],
         [0]),
Enchant('minion_ta_heat_damage',
         "28.0% to 50.0% Heat Damage Bonus for <font color='#00a1ff'>Constructs</font>",
         ['Plasma Caliver','Omnissian Axe','Radium Carbine','Voltaic Axe'],
         ['weapon'],
         'primary',
         false,
         [],
         [0]),
Enchant('minion_ta_heat_damage_minor',
         "14.0% to 30.0% Heat Damage Bonus for <font color='#00a1ff'>Constructs</font>",
         ['Eye Implant','Neural Implant','Purity Seal','Signum'],
         ['eye_implant','neural_implant','purity_seal','signum'],
         'secondary',
         false,
         [],
         [0]),
Enchant('minion_ta_heat_resist',
         "12.0 to 20.0 Supreme Heat Resist for <font color='#00a1ff'>Constructs</font> ",
         ['Belt Equipment','Force Field','Grenade','Mine','Psychic Focus','Archeotech Item','Power Armour','Light Armour','Synskin Armour','Tech-adept Armour'],
         ['belt','body'],
         'primary',
         false,
         [],
         [0]),
Enchant('minion_ta_heat_resist_minor',
         "12.0 to 20.0 Heat Resist for <font color='#00a1ff'>Constructs</font> ",
         ['Eye Implant','Inoculator','Main Implant','Neural Implant','Purity Seal'],
         ['eye_implant','inoculator','main_implant','neural_implant','purity_seal'],
         'secondary',
         false,
         [],
         [0]),
Enchant('minion_ta_hp_cremator',
         "385.0 to 500.0 Base HP for <font color='#00A1FF'>Psiloi Combustors</font> ",
         ['Power Armour','Light Armour','Synskin Armour','Tech-adept Armour'],
         ['body'],
         'primary',
         false,
         [],
         [0]),
Enchant('minion_ta_hp_kastellan',
         "1100.0 to 1400.0 Base HP for <font color='#00A1FF'>Kastelan Robots</font> ",
         ['Power Armour','Light Armour','Synskin Armour','Tech-adept Armour'],
         ['body'],
         'primary',
         false,
         [],
         [0]),
Enchant('minion_ta_hp_kataphron_destroyer',
         "1100.0 to 1300.0 Base HP for <font color='#00A1FF'>Kataphron Destroyers</font> ",
         ['Power Armour','Light Armour','Synskin Armour','Tech-adept Armour'],
         ['body'],
         'primary',
         false,
         [],
         [0]),
Enchant('minion_ta_hp_kataphron_vanguard',
         "1350.0 to 1700.0 Base HP for <font color='#00A1FF'>Kataphron Vanguards</font> ",
         ['Power Armour','Light Armour','Synskin Armour','Tech-adept Armour'],
         ['body'],
         'primary',
         false,
         [],
         [0]),
Enchant('minion_ta_hp_minor',
         "0.03 to 0.04 HP for <font color='#00A1FF'>Constructs</font> ",
         ['Belt Equipment','Force Field','Grenade','Mine','Psychic Focus','Archeotech Item','Inoculator','Main Implant','Power Armour','Light Armour','Purity Seal','Synskin Armour','Tech-adept Armour'],
         ['belt','body','inoculator','main_implant','purity_seal'],
         'secondary',
         false,
         [],
         [0]),
Enchant('minion_ta_hp_regen',
         "25.0 to 35.0 HP regeneration for <font color='#00a1ff'>Constructs</font>",
         ['Belt Equipment','Force Field','Grenade','Mine','Psychic Focus','Archeotech Item','Main Implant','Power Armour','Light Armour','Synskin Armour','Tech-adept Armour'],
         ['belt','body','main_implant'],
         'secondary',
         false,
         [],
         [0]),
Enchant('minion_ta_hp_tarantula',
         "700.0 to 900.0 Base HP for <font color='#00A1FF'>Tarantula Turrets</font> ",
         ['Power Armour','Light Armour','Synskin Armour','Tech-adept Armour'],
         ['body'],
         'primary',
         false,
         [],
         [0]),
Enchant('minion_ta_hp_vivisector',
         "500.0 to 750.0 Base HP for <font color='#00A1FF'>Psiloi Vivisectors</font> ",
         ['Power Armour','Light Armour','Synskin Armour','Tech-adept Armour'],
         ['body'],
         'primary',
         false,
         [],
         [0]),
Enchant('minion_ta_melee_damage',
         "35.0% to 70.0% Melee Damage Bonus for <font color='#00a1ff'>Constructs</font>",
         ['Plasma Caliver','Omnissian Axe','Radium Carbine','Voltaic Axe'],
         ['weapon'],
         'primary',
         false,
         [],
         [0]),
Enchant('minion_ta_melee_damage_minor',
         "17.0% to 30.0% Melee Damage Bonus for <font color='#00a1ff'>Constructs</font>",
         ['Eye Implant','Neural Implant','Purity Seal','Signum'],
         ['eye_implant','neural_implant','purity_seal','signum'],
         'secondary',
         false,
         [],
         [0]),
Enchant('minion_ta_phys_resist',
         "12.0 to 20.0 Supreme Physical Resist for <font color='#00a1ff'>Constructs</font> ",
         ['Belt Equipment','Force Field','Grenade','Mine','Psychic Focus','Archeotech Item','Power Armour','Light Armour','Synskin Armour','Tech-adept Armour'],
         ['belt','body'],
         'primary',
         false,
         [],
         [0]),
Enchant('minion_ta_phys_resist_minor',
         "12.0 to 20.0 Physical Resist for <font color='#00a1ff'>Constructs</font> ",
         ['Eye Implant','Inoculator','Main Implant','Neural Implant','Purity Seal'],
         ['eye_implant','inoculator','main_implant','neural_implant','purity_seal'],
         'secondary',
         false,
         [],
         [0]),
Enchant('minion_ta_physical_damage',
         "28.0% to 50.0% Physical Damage Bonus for <font color='#00a1ff'>Constructs</font>",
         ['Plasma Caliver','Omnissian Axe','Radium Carbine','Voltaic Axe'],
         ['weapon'],
         'primary',
         false,
         [],
         [0]),
Enchant('minion_ta_physical_damage_minor',
         "14.0% to 30.0% Physical Damage Bonus for <font color='#00a1ff'>Constructs</font>",
         ['Eye Implant','Neural Implant','Purity Seal','Signum'],
         ['eye_implant','neural_implant','purity_seal','signum'],
         'secondary',
         false,
         [],
         [0]),
Enchant('minion_ta_ranged_damage',
         "28.0% to 50.0% Ranged Damage Bonus for <font color='#00a1ff'>Constructs</font>",
         ['Plasma Caliver','Omnissian Axe','Radium Carbine','Voltaic Axe'],
         ['weapon'],
         'primary',
         false,
         [],
         [0]),
Enchant('minion_ta_ranged_damage_minor',
         "13.0% to 16.0% Ranged Damage Bonus for <font color='#00a1ff'>Constructs</font>",
         ['Eye Implant','Neural Implant','Purity Seal','Signum'],
         ['eye_implant','neural_implant','purity_seal','signum'],
         'secondary',
         false,
         [],
         [0]),
Enchant('minion_ta_suppression_damage',
         "0.16 to 0.25 Suppression Damage Bonus for <font color='#00a1ff'>Constructs</font>",
         ['Eye Implant','Neural Implant','Signum'],
         ['eye_implant','neural_implant','signum'],
         'primary',
         false,
         [],
         [0]),
Enchant('minion_ta_warp_resist',
         "12.0 to 20.0 Supreme Warp Resist for <font color='#00a1ff'>Constructs</font> ",
         ['Belt Equipment','Force Field','Grenade','Mine','Psychic Focus','Archeotech Item','Power Armour','Light Armour','Synskin Armour','Tech-adept Armour'],
         ['belt','body'],
         'primary',
         false,
         [],
         [0]),
Enchant('minion_ta_warp_resist_minor',
         "12.0 to 20.0 Warp Resist for <font color='#00a1ff'>Constructs</font> ",
         ['Eye Implant','Inoculator','Main Implant','Neural Implant','Purity Seal'],
         ['eye_implant','inoculator','main_implant','neural_implant','purity_seal'],
         'secondary',
         false,
         [],
         [0]),
Enchant('minion_warp_resist',
         "45.0 to 50.0 Warp Resistance",
         ['Equipment Module','Equipment Module','Equipment Module','Equipment Module','Equipment Module','Weapon Module'],
         ['construct'],
         'primary',
         false,
         [],
         [0]),
Enchant('miniongodlike_area_damage_after_10_kills',
         "Every 10th enemy explodes on kill, dealing area damage equal <font color='#2bede6'>100%</font> of their HP ",
         ['Equipment Module','Equipment Module','Weapon Module','Weapon Module','Weapon Module','Weapon Module','Weapon Module','Weapon Module','Weapon Module','Weapon Module'],
         ['construct'],
         'relic',
         false,
         [],
         [0]),
Enchant('miniongodlike_area_large_damage_on_deadly_strike',
         "Single target attacks deal area damage around the target on a One-hit kill",
         ['Equipment Module','Equipment Module','Weapon Module','Weapon Module','Weapon Module','Weapon Module','Weapon Module','Weapon Module','Weapon Module','Weapon Module'],
         ['construct'],
         'relic',
         false,
         [],
         [0]),
Enchant('miniongodlike_bleed_on_hit',
         "20.0% to 50.0% chance to cause <font color='#fffdcb'>Bleeding</font> on Hit",
         ['Equipment Module','Equipment Module','Weapon Module','Weapon Module','Weapon Module','Weapon Module','Weapon Module','Weapon Module','Weapon Module','Weapon Module'],
         ['construct'],
         'relic',
         false,
         [],
         [0]),
Enchant('miniongodlike_chance_knockback_and_slow_on_hit',
         "20.0% to 50.0% chance to <font color='#fffdcb'>Slow</font> or <font color='#fffdcb'>Knockback</font> on Hit",
         ['Equipment Module','Equipment Module','Weapon Module','Weapon Module','Weapon Module','Weapon Module','Weapon Module','Weapon Module','Weapon Module','Weapon Module'],
         ['construct'],
         'relic',
         false,
         [],
         [0]),
Enchant('miniongodlike_chance_to_cast_fabricator_scatter_field_on_struck',
         "20.0% to 50.0% chance to trigger a Fabricatus Scatter Field on Hit taken",
         ['Equipment Module','Equipment Module'],
         ['construct'],
         'relic',
         false,
         [],
         [0]),
Enchant('miniongodlike_chance_to_enemies_explode',
         "<font color='#2bede6'>+15%</font> Chance for enemies to explode on kill, dealing area damage equal 20.0% to 50.0% of their HP ",
         ['Equipment Module','Equipment Module','Weapon Module','Weapon Module','Weapon Module','Weapon Module','Weapon Module','Weapon Module','Weapon Module','Weapon Module'],
         ['construct'],
         'relic',
         false,
         [],
         [0]),
Enchant('miniongodlike_chance_to_lightning_bolt_in_area',
         "20.0% to 50.0% chance to create electric arcs on Melee Hit. The arcs hit the 6 additional enemies with 6.5 meters for <font color='#2bede6'>350%</font> Base damage as Heat and <font color='#fffdcb'>Shock</font> them.",
         ['Weapon Module','Weapon Module','Weapon Module','Weapon Module','Weapon Module','Weapon Module','Weapon Module','Weapon Module'],
         ['construct'],
         'relic',
         false,
         [],
         [0]),
Enchant('miniongodlike_damage',
         "10.0% to 15.0% Damage Bonus",
         ['Equipment Module','Equipment Module','Weapon Module','Weapon Module','Weapon Module','Weapon Module','Weapon Module','Weapon Module','Weapon Module','Weapon Module'],
         ['construct'],
         'relic',
         false,
         [],
         [0]),
Enchant('miniongodlike_damage_based_on_missing_hp',
         "<font color='#2bede6'>+1%</font> Damage Bonus for every 1% HP missing",
         ['Weapon Module','Weapon Module','Weapon Module','Weapon Module','Weapon Module','Weapon Module','Weapon Module','Weapon Module'],
         ['construct'],
         'relic',
         false,
         [],
         [0]),
Enchant('miniongodlike_damage_bonus_based_on_debuff',
         "10.0% to 30.0% Damage Bonus for every Debuff on the target",
         ['Equipment Module','Equipment Module','Weapon Module','Weapon Module','Weapon Module','Weapon Module','Weapon Module','Weapon Module','Weapon Module','Weapon Module'],
         ['construct'],
         'relic',
         false,
         [],
         [0]),
Enchant('miniongodlike_damage_on_low_hp',
         "0.4 to 1.0 Damage Bonus for the Construct when in <font color='#fffdcb'>Exposed</font> State",
         ['Equipment Module','Equipment Module','Weapon Module','Weapon Module','Weapon Module','Weapon Module','Weapon Module','Weapon Module','Weapon Module','Weapon Module'],
         ['construct'],
         'relic',
         false,
         [],
         [0]),
Enchant('miniongodlike_damage_per_minion_in_big_aura',
         "0.03 to 0.08 Damage Bonus for every nearby Construct",
         ['Weapon Module','Weapon Module','Weapon Module','Weapon Module','Weapon Module','Weapon Module','Weapon Module','Weapon Module'],
         ['construct'],
         'relic',
         false,
         [],
         [0]),
Enchant('miniongodlike_datapool_per_kill',
         "1.0 to 2.0 Focus/Adrenaline/Warp Heat/Data-flux gained on Kill",
         ['Weapon Module','Weapon Module','Weapon Module','Weapon Module','Weapon Module','Weapon Module','Weapon Module','Weapon Module'],
         ['construct'],
         'relic',
         false,
         [],
         [0]),
Enchant('miniongodlike_dr',
         "0.12 to 0.25 Supreme Damage Reduction",
         ['Equipment Module','Equipment Module'],
         ['construct'],
         'relic',
         false,
         [],
         [0]),
Enchant('miniongodlike_halucination_on_hit',
         "20.0% to 50.0% chance to cause <font color='#fffdcb'>Hallucination</font> on Hit",
         ['Equipment Module','Equipment Module','Weapon Module','Weapon Module','Weapon Module','Weapon Module','Weapon Module','Weapon Module','Weapon Module','Weapon Module'],
         ['construct'],
         'relic',
         false,
         [],
         [0]),
Enchant('miniongodlike_heat_resist',
         "40.0 to 60.0 Heat Resistance",
         ['Equipment Module','Equipment Module'],
         ['construct'],
         'relic',
         false,
         [],
         [0]),
Enchant('miniongodlike_hp_regen',
         "5.0% to 9.0% HP regeneration per second",
         ['Equipment Module','Equipment Module'],
         ['construct'],
         'relic',
         false,
         [],
         [0]),
Enchant('miniongodlike_physical_resist',
         "40.0 to 60.0 Physical Resistance",
         ['Equipment Module','Equipment Module'],
         ['construct'],
         'relic',
         false,
         [],
         [0]),
Enchant('miniongodlike_poison_dot_on_hit',
         "20.0% to 50.0% chance to <font color='#fffdcb'>Poison</font> on Hit",
         ['Equipment Module','Equipment Module','Weapon Module','Weapon Module','Weapon Module','Weapon Module','Weapon Module','Weapon Module','Weapon Module','Weapon Module'],
         ['construct'],
         'relic',
         false,
         [],
         [0]),
Enchant('miniongodlike_shock_on_hit',
         "20.0% to 50.0% chance to <font color='#2bede6'>Shock</font> on Hit",
         ['Equipment Module','Equipment Module','Weapon Module','Weapon Module','Weapon Module','Weapon Module','Weapon Module','Weapon Module','Weapon Module','Weapon Module'],
         ['construct'],
         'relic',
         false,
         [],
         [0]),
Enchant('miniongodlike_slow_on_kill',
         "Chance to cause an <font color='#fffdcb'>Slow</font> effect in a small area based on enemy type on Kill",
         ['Equipment Module','Equipment Module','Weapon Module','Weapon Module','Weapon Module','Weapon Module','Weapon Module','Weapon Module','Weapon Module','Weapon Module'],
         ['construct'],
         'relic',
         false,
         [],
         [0]),
Enchant('miniongodlike_stun_immunity',
         "The Construct is immune to <font color='#fffdcb'>Stun</font> effects",
         ['Equipment Module','Equipment Module'],
         ['construct'],
         'relic',
         false,
         [],
         [0]),
];


export default ItemMap;



